import { BlockerActionEndFlowActionResult } from '@cash-web/protos/squareup/franklin/blocker_action.pb'
import { FlowResponse } from '@cash-web/shared-flow-data-access-context'

export const handleCustomFlowResponses = (response: FlowResponse): FlowResponse => {
  /**
   * NOTE: blocker disclosures do not handle dismiss actions properly
   * since it was created a long time ago when there weren’t established patterns.
   * This is a temporary fix until mobile moves over to use dismiss actions.
   */
  const disclosureBlocker = response.response_context?.scenario_plan?.blocker_descriptors?.[0]?.blocker?.disclosure
  if (disclosureBlocker) {
    return {
      ...response,
      response_context: {
        ...response.response_context,
        scenario_plan: {
          ...response.response_context?.scenario_plan,
          blocker_descriptors: [
            {
              ...response.response_context?.scenario_plan?.blocker_descriptors?.[0],
              dismiss_action: {
                confirmation_dialog: {
                  message: disclosureBlocker?.cancel_dialog_text,
                  confirm_button_text: disclosureBlocker?.cancel_dialog_confirm_text,
                  cancel_button_text: disclosureBlocker?.cancel_dialog_cancel_text,
                },
                end_flow_action: {
                  result: BlockerActionEndFlowActionResult.CANCELLED,
                },
              },
            },
            ...(response.response_context?.scenario_plan?.blocker_descriptors?.slice(1) ?? []),
          ],
        },
      },
    }
  }
  return response
}
